import { chakra } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
  BEControlGroupProps,
  BEControlGroupDirectionType,
} from './BEControlGroupProps';

const BEControlGroup = chakra('div');

export const StyledBEControlGroup = styled(BEControlGroup)<BEControlGroupProps>`
  gap: ${(props) => (props.direction === 'horizontal' ? '24px' : '16px')};
  display: ${(props) =>
    props.display || props.direction === 'horizontal'
      ? 'inline-flex'
      : 'inline-grid'};
  ${(props) =>
    props.direction === 'horizontal' &&
    css`
    flex-wrap: wrap;
  `}
`;

export const StyledBEControlGroupBox = styled('div')<{
  direction: BEControlGroupDirectionType;
}>`
  display: flex;
  justify-content: ${(props) =>
    props.direction === 'horizontal' ? 'center' : null};
`;
